module.exports = __webpack_public_path__ + "img/Tri-Eko-Handayaningsih.792c212f.png";